import { theNewCssReset } from './theNewCssReset';
const resetStyles = [
    /* library reset */
    theNewCssReset,
];
export default resetStyles;
